import * as moment from "moment";
import { OrganizationSubscription } from "../public_api";

export enum Subscriptions {
    TASTINGS = 'tastings_module',
    EVALUATION ='evaluation_module',
    REPORTING = 'advanced_report_module',
}

export class OrganizationSubscriptionHandler {

    private subscriptions: OrganizationSubscription[] = [];

    constructor() {}

    setSubscriptions(subs: OrganizationSubscription[]) {
        this.subscriptions = subs;
    }

    getSubscriptions(): string[] {
        return this.subscriptions.map(sub => {return sub.moduleRef});
    }

    checkSubscription(subscriptionRef: Subscriptions) {
        let hasSubscription: boolean = this.subscriptions.map(sub => {return sub.moduleRef}).includes(subscriptionRef);
        let sub: OrganizationSubscription = this.getSub(subscriptionRef);
        let isActive: boolean = this.getActiveStatus(sub);

        return (isActive && hasSubscription);
    }

    private getActiveStatus(sub: OrganizationSubscription): boolean {
        if (!sub) return false;
        let now = moment();
        return (moment(sub.startAt) <= now && moment(sub.endAt) > now);
    }

    private getSub(ref: string): OrganizationSubscription {
        return this.subscriptions.find(sub => {return sub.moduleRef === ref});
    }
}